import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Button,
  Row,
  Col,
  Input
} from 'reactstrap';
import * as commonActions from '@common/common.action';
import { useDispatch } from 'react-redux';
import IntlMessage from "../../../../helpers/intlMessage";

export default function ModalIndicacao (props) {
  const [modalAberto, setModalAberto] = useState(false);
  const backdrop = !props.backdrop ? false : props.backdrop;
  const keyboard = props.keyboard === undefined ? true : props.keyboard;
  const dispatch = useDispatch();

  useEffect(() => {
    setModalAberto(props.showModalIndicacao);
    dispatch(commonActions.showModal(props.showModalIndicacao));
  }, [props.showModalIndicacao]);

  useEffect(()=>{
    changeIndicacao(props.indicacao);
   }, [props.indicacao]);

  function toggle () {
    setModalAberto(!modalAberto);
    dispatch(commonActions.showModal(!modalAberto));
    props.onModal(!modalAberto);
  }

  function changeIndicacao (el) {
    if (el.length > 200) {
      return;
    }
    props.setIndicacao(el);
  }

  return (
    <React.Fragment>
      <div>
        <Modal
          className='modal-confirm'
          backdrop={backdrop}
          keyboard={keyboard}
          centered
          isOpen={modalAberto}
          toggle={toggle}
        >
          <ModalHeader toggle={!props.close ? toggle : props.close}>
            <IntlMessage id = "dashboards.reports.informIndication"/>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col>
                <FormGroup className={`confirmar-primary`}>
                  <Label><IntlMessage id = "dashboards.reports.indication"/></Label>
                  <Input
                    type='textarea'
                    rows={3}
                    value={props.indicacao}
                    onChange={e => changeIndicacao(e.target.value)}
                  />
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              onClick={!props.cancelar ? toggle : props.cancelar}
              className={`button-cancel`}
              color='secondary'
            >
              <IntlMessage id = "dashboards.examDetails.cancel"/>
            </Button>
            <Button
              className={`button-confirm`}
              onClick={() => props.imprimir()}
              color='primary'
            >
              <IntlMessage id = "dashboards.reports.printOut"/>
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/pages/descarte/modais/indicacao/index.js